import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { CellsPool } from "../utils/CellsPool";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    
    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.loadAssets();
        this.composeScene();
    }

    public create(): void {    
        
        CellsPool.init(this); 

        GameManager.onGameAssetsLoaded(this.scene);       
    }

    private updateLoadedPercentage(file: any, percentageLoaded: number): void {

        this.progressBar.clear();
        this.progressBar.fillStyle(0xFFD300);
        this.progressBar.fillRect(0, GameConstants.GAME_HEIGHT - 6, percentageLoaded * GameConstants.GAME_WIDTH, 6);
    }

    private composeScene(): void {
        
        this.progressBar = this.add.graphics();

        this.add.text(5, GameConstants.GAME_HEIGHT - 38, "LOADING ...", { fontFamily: "FredokaOne", fontSize: 24, color: "#ffffff"})
            .setShadow(1, 1, "#333333", 2, false, true);

        // Create Background Images
        let backgroundImage = this.add.image(0, 0, "texture_atlas_1", "background.png");
        backgroundImage.setDisplaySize(GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        backgroundImage.setOrigin(0); 
    }

    private loadAssets(): void {
        
        // Load atlas 
        this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");

        this.load.on("fileprogress", this.updateLoadedPercentage, this);

        // Load fonts 
        this.load.bitmapFont("arial", "assets/fonts/arial.png", "assets/fonts/arial.xml");
        this.load.bitmapFont("btm_fredoka", "assets/fonts/fredoka.png", "assets/fonts/fredoka.xml");

        // Load audio
        this.load.audioSprite("audio-sprite", "assets/audio/audiosprite.json", ["assets/audio/audiosprite.mp3", "assets/audio/audiosprite.ogg"]);
    }
}
